var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAntler = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 18,
    fill: "none",
    viewBox: "0 0 75 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED4746",
    fillRule: "evenodd",
    d: "M0 9v9h17.885V0H0zm33.28-4.251v.842h3.18v8.464h1.838V5.591h3.179V3.906H33.28zM44.77 8.98v5.074h7.085V12.37H46.57V3.906h-1.8zm10.34 0v5.074h7.507V12.41h-5.898V9.766h4.52V8.119h-4.52V5.553h5.898V3.906h-7.506zm11.069 0v5.074h1.8v-3.523l1.1.002 1.102.002 1.228 1.75 1.228 1.75 1.065.01c.855.009 1.06 0 1.045-.039-.01-.027-.577-.833-1.26-1.79L72.16 10.35c-.082-.117-.084-.126-.018-.149.212-.072.697-.293.886-.403.12-.07.374-.283.566-.474.283-.28.378-.406.508-.67.254-.518.322-.836.322-1.511 0-.672-.068-.997-.315-1.494-.48-.97-1.466-1.562-2.839-1.703-.223-.023-1.385-.04-2.74-.04h-2.35zm-54.261-.038 2.192 5.026c.015.038-.177.048-.889.047h-.908l-1.682-3.973A403 403 0 0 0 8.924 6.04c-.014-.016-.79 1.772-1.724 3.974l-1.697 4.003H3.757l.052-.124c.134-.32 4.283-9.821 4.315-9.881.034-.063.101-.068.83-.059l.792.01zM21.217 9v5.055h1.761l.01-3.54.01-3.54 2.738 3.54 2.738 3.54h1.552V3.945h-1.8l-.01 3.447-.01 3.446-2.661-3.444-2.662-3.445-.833-.002-.833-.002zm50.017-3.354c.553.117 1.013.44 1.205.846.383.81.085 1.74-.691 2.151-.46.245-.53.253-2.228.27l-1.541.016V5.59l1.503.001c1.13 0 1.565.014 1.752.054",
    clipRule: "evenodd"
  })));
};
export default SvgAntler;